// 이 PC 가 **지금 원격지원을 받는 중인가**(피제어 세션) + 원격지 채팅 창 열기 — 2026-09-29 사용자 요청.
// 홈 화면의 [지원 담당자와 대화] 단추가 쓴다(원격지에서 **먼저** 말 걸기 — 대화 통로는 접속 중에만 있다).
// ⚠️ 뷰어 쪽 `App.sessionActive`(내가 남에게 접속 중)와 다르다 — 여기는 **남이 이 PC 에 접속 중**이다.
import { useCallback, useEffect, useState } from 'react';
import { invoke } from '@tauri-apps/api/core';
import { listen } from '@tauri-apps/api/event';
import { IS_SHELL } from '../../shell';

/** 세션 상태 이벤트·조회 명령. 🔴 Rust 껍데기(`rs-session` 방출 · `agent_session_active`)와 같아야 한다. */
export const HOST_SESSION_EVENT = 'rs-session';
export const HOST_SESSION_QUERY = 'agent_session_active';
/** 원격지 채팅 창을 여는 명령. 🔴 Rust `agent_chat::open_agent_chat_window` 와 같아야 한다. */
export const OPEN_AGENT_CHAT = 'open_agent_chat_window';

export interface HostSession {
  /** 남이 이 PC 에 원격 접속 중. 브라우저 뷰어면 늘 false. */
  active: boolean;
  /** 원격지 채팅 창을 연다(포커스와 함께 — 사람이 누른 것). */
  openChat(): void;
}

export function useHostSession(): HostSession {
  const [active, setActive] = useState(false);
  useEffect(() => {
    if (!IS_SHELL) return;
    const un = listen<{ active?: boolean }>(HOST_SESSION_EVENT, (e) => setActive(!!e.payload?.active));
    // 구독 직후 최신값을 직접 묻는다(리스너를 달기 전에 온 갱신 유실 방지 — `useMyDeviceCode` 와 같은 이유).
    invoke<boolean>(HOST_SESSION_QUERY).then((v) => setActive(!!v)).catch(() => {});
    return () => {
      void un.then((f) => f());
    };
  }, []);
  const openChat = useCallback(() => {
    void invoke(OPEN_AGENT_CHAT).catch(() => {});
  }, []);
  return { active, openChat };
}
